import NavBar from './NavBar';
import Search from './Search/Search';

export { Search as NavBarSearch };
export default NavBar;
